import { DrawingsPendingHaulageListConfig } from './_models';

export class SetDrawingsPendingHaulageListConfig {
  static readonly type = '[Drawings Pending Haulage List] Set List Config';
  constructor(public config: DrawingsPendingHaulageListConfig) {}
}

export class DrawingsPendingHaulageCountsUpdated {
  static readonly type = '[Drawings Pending Haulage List] Counts Updated';
  constructor(
    public deliveredCount: number,
    public exStoreCount: number,
  ) {}
}
